export default __webpack_public_path__ + "static/media/table-size-card.8e8eb2c4.svg";